import api from './api';

class WalletTopupService {
    /**
     * Get all wallet topup requests with filters
     * @param {Object} params - Query parameters (status, buyer_id, page, limit)
     * @returns {Promise} API response
     */
    async getAllRequests(params = {}) {
        try {
            const response = await api.get('/payments/admin/all', { params });
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    /**
     * Get pending wallet topup requests
     * @param {Object} params - Query parameters (page, limit)
     * @returns {Promise} API response
     */
    async getPendingRequests(params = {}) {
        try {
            const response = await api.get('/payments/admin/pending', { params });
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    /**
     * Approve wallet topup request
     * @param {Number} id - Payment request ID
     * @param {String} admin_notes - Optional admin notes
     * @returns {Promise} API response
     */
    async approveRequest(id, admin_notes = '') {
        try {
            const response = await api.put(`/payments/admin/${id}/approve`, {
                admin_notes
            });
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    /**
     * Reject wallet topup request
     * @param {Number} id - Payment request ID
     * @param {String} admin_notes - Rejection reason
     * @returns {Promise} API response
     */
    async rejectRequest(id, admin_notes) {
        try {
            const response = await api.put(`/payments/admin/${id}/reject`, {
                admin_notes
            });
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    /**
     * Handle API errors
     * @param {Error} error - Error object
     * @returns {Error} Formatted error
     */
    handleError(error) {
        if (error.response) {
            const message = error.response.data.message || 'An error occurred';
            const err = new Error(message);
            err.status = error.response.status;
            err.data = error.response.data;
            return err;
        }
        return new Error('Network error. Please check your connection.');
    }
}

export default new WalletTopupService();
